module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/cybermonday-productos-mobile.8690bd3b.png";